module.exports = __webpack_public_path__ + "public/img/gwc.ae180a0d.png";